import { z } from 'zod';

export const deliveryItemSchema = z.object({
  id: z.string().optional(),
  productId: z.string().min(1, 'Vui lòng chọn sản phẩm'),
  productName: z.string().min(1, 'Tên sản phẩm không được trống'),
  unit: z.string().min(1, 'Đơn vị tính không được trống'),
  poNumber: z.string().optional().nullable(),
  soNumber: z.string().optional().nullable(),
  quantity: z.number().min(0.01, 'Số lượng phải lớn hơn 0'),
  deliveredQty: z.number().min(0, 'Số lượng giao không được âm'),
  lossQty: z.number().min(0, 'Số lượng hao hụt không được âm').default(0),
  countedQty: z.number().min(0).default(0),
  unitPrice: z.number().min(0, 'Đơn giá không được âm').default(0),
  amount: z.number().min(0).default(0),
  orderDetailId: z.string().optional().nullable(),
});

export const deliveryFormSchema = z.object({
  deliveryId: z.string().optional(),
  customerId: z.string().min(1, 'Khách hàng không được để trống'),
  orderId: z.string().optional().nullable(),
  salesUserId: z.string().optional().nullable(),
  deliveryDate: z.string().min(1, 'Ngày giao hàng không được để trống'),
  address: z.string().optional().nullable(),
  transshipmentAddr: z.string().optional().nullable(),
  deliveryType: z.enum(['TRUC_TIEP', 'CHUYEN_PHAT', 'XE_KHACH', 'KHAC']).default('TRUC_TIEP'),
  deliveryFee: z.number().min(0).default(0),
  receiverName: z.string().optional().nullable(),
  receiverPhone: z.string().optional().nullable(),
  driverName: z.string().optional().nullable(),
  vehicleNumber: z.string().optional().nullable(),
  status: z.enum(['DRAFT', 'CONFIRMED', 'DELIVERING', 'DELIVERED', 'CANCELLED']).default('DRAFT'),
  notes: z.string().optional().nullable(),
  totalAmount: z.number().min(0).default(0),
  deliveryItems: z.array(deliveryItemSchema).min(1, 'Cần ít nhất 1 mặt hàng giao'),
});

export type DeliveryItemFormData = z.infer<typeof deliveryItemSchema>;
export type DeliveryFormData = z.infer<typeof deliveryFormSchema>;

export interface Delivery {
    id: string;
    deliveryId: string;
    customerId: string;
    orderId?: string | null;
    salesUserId?: string | null;
    deliveryDate: string | Date;
    address?: string | null;
    transshipmentAddr?: string | null;
    deliveryType: 'TRUC_TIEP' | 'CHUYEN_PHAT' | 'XE_KHACH' | 'KHAC';
    deliveryFee: number;
    receiverName?: string | null;
    receiverPhone?: string | null;
    driverName?: string | null;
    vehicleNumber?: string | null;
    status: 'DRAFT' | 'CONFIRMED' | 'DELIVERING' | 'DELIVERED' | 'CANCELLED';
    notes?: string | null;
    totalAmount: number;
    customer?: {
        id: string;
        code: string;
        name: string;
        shortName?: string | null;
    };
    salesUser?: {
        id: string;
        fullName: string;
        avatar?: string | null;
    } | null;
    deliveryItems?: DeliveryItemFormData[];
    _count?: {
        deliveryItems: number;
    };
    createdAt?: string | Date;
    updatedAt?: string | Date;
}
